import _ from "lodash";
import { GreenhouseDepartment, DepartmentStructure } from "../../types";

const mergeSortDepartments = (datasets: DepartmentStructure[]) => {
  const combinedDeptsWithDupes = _.flatMap(datasets, "departments");

  const mergeTwoDepartments = (dept1: GreenhouseDepartment, dept2: GreenhouseDepartment) => {
    return {
      ...dept1,
      jobs: _.orderBy(_.uniqBy([...dept1.jobs, ...dept2.jobs], "id"), "title", "asc"),
      child_ids: _.uniq([...(dept1.child_ids || []), ...(dept2.child_ids || [])]),
    };
  };

  const mergedDepartments = _.values(_.groupBy(_.flatten(combinedDeptsWithDupes), "name")).map((mergedDept) =>
    mergedDept.reduce(mergeTwoDepartments)
  );

  return _.orderBy(mergedDepartments, "name", "asc");
};

export { mergeSortDepartments };
